import { render, staticRenderFns } from "./CollectPopup.vue?vue&type=template&id=493a5deb&scoped=true&"
import script from "./CollectPopup.vue?vue&type=script&lang=ts&"
export * from "./CollectPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CollectPopup.vue?vue&type=style&index=0&id=493a5deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a5deb",
  null
  
)

export default component.exports